import React, { useEffect, useState } from "react";
import { useStore } from "../../contexts/store-provider";
import { MiscellaneousSettingKeyConstant } from "../../constants/miscellaneous-setting-key-constant";
import { observer } from "mobx-react";
import FormLoader from "../FormLoader/FormLoader";
import toast from "react-hot-toast";
import { formatMessage } from "../../translations/format-message";
import ConfirmPopupHOC from "../popup/confirm/confirm-popup-hoc";
import ConfirmPopup from "../popup/confirm/confirm-popup";
import { FormattedMessage } from "react-intl";

interface IProps{
  showConfirmPopup: boolean;
  confirmPopupToggleHandler: () => void;
}

const ShowBusinessTypeFilterSlider = (props: IProps) => {
  const { masterManagementStore } = useStore();
  const {GetMiscellaneousSettingByKeyService, getMiscellaneousSettingByKeyDetail, getMiscellaneousSettingByKeyState, UpdateMiscellaneousSettingService,
    updateMiscellaneousSettingByKeyState, resetGetMiscellaneousSettingByKeyState, resetUpdateMiscellaneousSettingByKeyState
  } = masterManagementStore;

  const [showFilter, setShowFilter] = useState<boolean>(getMiscellaneousSettingByKeyDetail);
  
  const toggleSwitch = (e: any) => {
    const value = e.target.checked
    setShowFilter(value);
    props.confirmPopupToggleHandler();
  };

  const UpdateHandler = () => {
    UpdateMiscellaneousSettingService(MiscellaneousSettingKeyConstant.ShowFilter, showFilter);
  };

  useEffect(()=>{
    GetMiscellaneousSettingByKeyService(MiscellaneousSettingKeyConstant.ShowFilter)
  },[]);
  
  useEffect(()=>{
    if(updateMiscellaneousSettingByKeyState.success){
      props.confirmPopupToggleHandler();
      toast.success(formatMessage("updated_success"));
      GetMiscellaneousSettingByKeyService(MiscellaneousSettingKeyConstant.ShowFilter);
      resetUpdateMiscellaneousSettingByKeyState();
    }
  },[updateMiscellaneousSettingByKeyState.success]);

  return (
    <div className="text-center">
      {props.showConfirmPopup && (
        <ConfirmPopup
          isLoading={updateMiscellaneousSettingByKeyState.inProgress}
          title={formatMessage("set_business_type_filter_setting")}
          message={formatMessage("set_business_type_filter_setting_info")}
          modalSubmit={UpdateHandler}
          modalClosed={props.confirmPopupToggleHandler}
        />
      )}
      {
        (updateMiscellaneousSettingByKeyState.inProgress || getMiscellaneousSettingByKeyState.inProgress) &&
        <FormLoader loading={updateMiscellaneousSettingByKeyState.inProgress || getMiscellaneousSettingByKeyState.inProgress} />
      }
      <div className="language-toggle">
        <span className={!getMiscellaneousSettingByKeyDetail ? "active" : ""}><FormattedMessage id="hide" /></span>
        <label className="switch mx-2">
          <input
            type="checkbox"
            checked={getMiscellaneousSettingByKeyDetail}
            onChange={(e:any)=>{toggleSwitch(e)}}
          />
          <span className="slider round"></span>
        </label>
        <span className={getMiscellaneousSettingByKeyDetail ? "active" : ""}><FormattedMessage id="show" /></span>
      </div>
    </div>
  );
};

export default ConfirmPopupHOC(observer(ShowBusinessTypeFilterSlider));
